"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NewsDetails = void 0;
var react_1 = __importStar(require("react"));
var react_router_1 = require("react-router");
var axios_1 = __importDefault(require("axios"));
var react_2 = require("@chakra-ui/react");
var layout_1 = require("../../../common/layout");
var PageNotFound_1 = require("../../../common/error/PageNotFound");
var PageLoading_1 = require("../../../common/loading/PageLoading");
var useShop_1 = require("../../../common/hooks/useShop");
var PageLoadingLayout_1 = require("../../../common/layout/PageLoadingLayout");
var ContentLayout_1 = require("../../../common/layout/ContentLayout");
var scrollToTopButton_1 = require("../../../common/layout/components/scrollToTopButton");
var useSetMeta_1 = require("../../../common/hooks/useSetMeta");
var NewsDetails = function () {
    var _a = (0, useShop_1.useShop)(), shopData = _a.shopData, isShopLoading = _a.isShopLoading, mainShopData = _a.mainShopData;
    var _b = (0, react_1.useState)(null), NewsDatas = _b[0], setNewsDatas = _b[1];
    var _c = (0, react_1.useState)(true), isNewsLoading = _c[0], setIsNewsLoading = _c[1];
    var params = (0, react_router_1.useParams)();
    (0, react_1.useEffect)(function () {
        axios_1.default
            .get("/api/news/" + params.shop_code + "/" + params.news_id)
            .then(function (response) {
            setNewsDatas(response.data);
        })
            .catch()
            .finally(function () {
            setIsNewsLoading(false);
        });
    }, []);
    if (isShopLoading || isNewsLoading)
        return react_1.default.createElement(PageLoading_1.PageLoading, null);
    if (!shopData)
        return (react_1.default.createElement(layout_1.Layout, { headerUrl: mainShopData === null || mainShopData === void 0 ? void 0 : mainShopData.logo_image },
            react_1.default.createElement(react_2.Box, { padding: "5rem" },
                react_1.default.createElement(PageNotFound_1.PageNotFound, null))));
    return (react_1.default.createElement(layout_1.Layout, { headerUrl: shopData.logo_image, isHeader: true, isFooter: true, isInquire: true, isLoading: isNewsLoading },
        react_1.default.createElement(PageLoadingLayout_1.PageLoadingLayout, { isLoading: isNewsLoading },
            NewsDatas ? (react_1.default.createElement(react_1.default.Fragment, null,
                (0, useSetMeta_1.useSetMeta)("" + NewsDatas.news.title),
                react_1.default.createElement(ContentLayout_1.ContentLayout, { contentBlocksData: NewsDatas.news.contents }))) : (react_1.default.createElement(react_1.default.Fragment, null,
                (0, useSetMeta_1.useSetMeta)("\u8A72\u5F53\u306E\u304A\u77E5\u3089\u305B\u304C\u898B\u3064\u304B\u308A\u307E\u305B\u3093\u3067\u3057\u305F\u3002"),
                " ",
                react_1.default.createElement(react_2.Box, { padding: "5rem" },
                    react_1.default.createElement(PageNotFound_1.PageNotFound, null)))),
            react_1.default.createElement(scrollToTopButton_1.ScrollToTopButton, null))));
};
exports.NewsDetails = NewsDetails;
